import type { CompassConfig } from './location-select.types';
import {
	CompassAPI,
	type CompassGeocodeLocation,
	type CompassGeocodeParams,
} from './compass-api';

export class CompassService {
	compassAPI: CompassAPI;

	constructor(config: CompassConfig) {
		this.compassAPI = new CompassAPI(config.baseURL, config.APIKey);
	}

	async geocode(params: CompassGeocodeParams): Promise<CompassGeocodeLocation> {
		const { data } = await this.compassAPI.geocode(params);

		return data;
	}
}
